import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    actions: {
        id: 'iaso.label.actions',
        defaultMessage: 'Action(s)',
    },
    details: {
        id: 'iaso.label.details',
        defaultMessage: 'Details',
    },
    no: {
        id: 'iaso.label.no',
        defaultMessage: 'No',
    },
    yes: {
        id: 'iaso.label.yes',
        defaultMessage: 'Yes',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    updatedAt: {
        id: 'iaso.label.updated_at',
        defaultMessage: 'Updated',
    },
    chronogramTitle: {
        id: 'iaso.polio.chronogram.title',
        defaultMessage: 'Chronogram',
    },
    labelCampaign: {
        id: 'iaso.polio.chronogram.label.campaign',
        defaultMessage: 'Campaign',
    },
    labelCountry: {
        id: 'iaso.polio.chronogram.label.country',
        defaultMessage: 'Country',
    },
    labelRound: {
        id: 'iaso.polio.chronogram.label.round',
        defaultMessage: 'Round',
    },
    labelId: {
        id: 'iaso.label.id',
        defaultMessage: 'Identifier',
    },
    labelCampaignObrName: {
        id: 'iaso.polio.chronogram.label.campaign_obr_name',
        defaultMessage: 'Campaign',
    },
    filterLabelCampaign: {
        id: 'iaso.polio.chronogram.filter.label.campaign',
        defaultMessage: 'Campaign',
    },
    filterLabelCountry: {
        id: 'iaso.polio.chronogram.filter.label.country',
        defaultMessage: 'Country',
    },
    labelIsOnTime: {
        id: 'iaso.polio.chronogram.label.is_on_time',
        defaultMessage: 'On time',
    },
    labelNumTaskDelayed: {
        id: 'iaso.polio.chronogram.label.num_task_delayed',
        defaultMessage: 'Number of task(s) delayed',
    },
    labelPercentageOfCompletion: {
        id: 'iaso.polio.chronogram.label.percentage_of_completion',
        defaultMessage: 'Percentage of Completion Before/During/After',
    },
    labelRoundNumber: {
        id: 'iaso.polio.chronogram.label.round_number',
        defaultMessage: 'Round',
    },
    labelRoundStartDate: {
        id: 'iaso.polio.chronogram.label.round_start_date',
        defaultMessage: 'Date',
    },
    filterLabelSearch: {
        id: 'iaso.polio.chronogram.filter.label.search',
        defaultMessage: 'Search',
    },
    filterLabelOnTime: {
        id: 'iaso.polio.chronogram.filter.label.on_time',
        defaultMessage: 'On time',
    },
    linkToChronogramTemplateTask: {
        id: 'iaso.polio.chronogram.link_to_chronogram_template_task',
        defaultMessage: 'Edit Default Tasks',
    },
    messageCreateSuccess: {
        id: 'iaso.polio.chronogram.message.create_success',
        defaultMessage: 'Chronogram successfully created',
    },
    modalDeleteConfirm: {
        id: 'iaso.polio.chronogram.modal.delete.confirm',
        defaultMessage: `Do you really want to delete the chronogram for round {round_number} of {campaignName}?`,
    },
    modalDeleteTitle: {
        id: 'iaso.polio.chronogram.modal.delete.title',
        defaultMessage: 'Delete Chronogram',
    },
    createChronogramTitle: {
        id: 'iaso.polio.chronogram.title.create_chronogram',
        defaultMessage: 'Create a new chronogram',
    },
    requiredField: {
        id: 'iaso.forms.error.fieldRequired',
        defaultMessage: 'This field is required',
    },
    requiredPositiveInteger: {
        id: 'iaso.forms.error.positiveInteger',
        defaultMessage: 'Please use a positive integer',
    },
    requiredUuid: {
        id: 'iaso.forms.error.requiredUuid',
        defaultMessage: 'Please use an UUID',
    },
    round: {
        id: 'iaso.polio.label.round',
        defaultMessage: 'Round',
    },
});

export default MESSAGES;
